import { PlanCard } from "../components/planloader";
import { Link } from "react-router-dom";
import scrollToTop from "../components/scrolltotop";

const PlansPage = () => {
  return (
    <div className="plans-page-container">
      <div className="intro">
        <h2>Choose what you want, leave what you don’t</h2>
        <div className="sub">
          All over the UK different schools have different topic requirements.
          Our courses give parents the opportunity to only select what they
          need.
        </div>
      </div>
      <div className="inner">
        <div className="sectgroup">
          <div className="sect2">
            <div className="row">
              <h2>From the full 11+ course,</h2>
              <p className="sub">
                For complete preparation across maths, English, verbal and
                non-verbal reasoning, our comprehensive 11+ course builds
                mastery.
              </p>
            </div>
            <div className="close">
              <span className="video">
                <video
                  alt="ani"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  disablePictureInPicture
                  controlsList="nodownload nofullscreen noremoteplayback"
                >
                  <source
                    src="https://d1sq738v7irhr2.cloudfront.net/animations/juggling.mp4"
                    type="video/mp4"
                  />
                </video>
              </span>
              <PlanCard planKey="full11-g2" className="plan" />
            </div>
          </div>
          <div className="sect3">
            <h2>...to smart pairings...</h2>
            <p className="sub">
              Explore our powerful two-subject courses designed to strengthen
              skills, boost confidence, and maximise results.
            </p>
            <div className="close">
              <div className="list">
                <PlanCard planKey="core11-g2" />
                <PlanCard planKey="reason11-g2" />
                <PlanCard planKey="engvr-g2" />
                <PlanCard planKey="mathsnvr-g2" />
              </div>
              <span className="video">
                <video
                  alt="ani"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  disablePictureInPicture
                  controlsList="nodownload nofullscreen noremoteplayback"
                >
                  <source
                    src="https://d1sq738v7irhr2.cloudfront.net/animations/yoyo.mp4"
                    type="video/mp4"
                  />
                </video>
              </span>
            </div>
          </div>
        </div>
        <div className="sectgroup">
          <div className="sect4">
            <h2>...to individual subject focus.</h2>
            <p className="sub">
              If you want to focus on one subject and build skills with targeted
              support, a single-subject course is for you
            </p>
            <div className="close">
              <span className="video">
                <video
                  alt="ani"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  disablePictureInPicture
                  controlsList="nodownload nofullscreen noremoteplayback"
                >
                  {" "}
                  <source
                    src="https://d1sq738v7irhr2.cloudfront.net/animations/glass.mp4"
                    type="video/mp4"
                  />
                </video>
              </span>
              <div className="list">
                <PlanCard planKey="maths-g2" />
                <PlanCard planKey="english-g2" />
                <PlanCard planKey="vr-g2" />
                <PlanCard planKey="nvr-g2" />
              </div>
            </div>
          </div>
          <div className="sect5">
            <div className="row">
              <h2>We even have a special trio</h2>
              <p className="sub">
                Some schools only require Maths, English and Verbal reasoning.
                If that is the case for your target school, we have the plan for
                you!
              </p>
            </div>
            <div className="close">
              <PlanCard planKey="trio-g2" />
              <span className="video">
                <video
                  alt="ani"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  disablePictureInPicture
                  controlsList="nodownload nofullscreen noremoteplayback"
                >
                  <source
                    src="https://d1sq738v7irhr2.cloudfront.net/animations/stacking.mp4"
                    type="video/mp4"
                  />
                </video>
              </span>
            </div>
          </div>
        </div>

        <div className="finale">
          <h2>Start learning now!</h2>
          <p>
            We have something for everyone. Now that you have had a moment to
            browse our plans, let’s get straight to work!
          </p>
          <Link to="/getstarted" className="btn back" onClick={scrollToTop}>
            Get started today!
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PlansPage;
